Namespace 'Models.Visitors'

class Models.Visitors.InstagramMessageMainTextVisitor
  constructor: ->
    @mainText = ''

  visit_instagram_message_text: (message) ->
    @mainText = message.messageText

  visit_instagram_message_media: (message) ->
    @mainText = ''

  visit_instagram_message_story_mention: (message) ->
    @mainText = ''

  visit_instagram_message_story_reply: (message) ->
    @mainText = message.messageText

  visit_instagram_message_unsupported: (message) ->
    @mainText = 'Unsupported format'
